<script setup>
import { storeToRefs } from "pinia";
import { useResumoDesempenhoStore } from "@/store/resumoDesempenhoStore";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Tag from "primevue/tag";
import HeaderDetailsPage from "@/components/layout/HeaderDetailsPage.vue";
import Dropdown from "primevue/dropdown";
import { ref, onMounted } from "vue";
import { getSeverityFromNota } from "@/utils/getSeverityFromNota";

const store = useResumoDesempenhoStore();
const { turmas, turmaSelecionada, estudantes, loading } = storeToRefs(store);

onMounted(() => {
    calculateHeight();
})
const tableHeight = ref('auto');

function calculateHeight() {
    const viewportHeight = window.innerHeight;
    const desiredHeight = viewportHeight - 140;
    tableHeight.value = `${desiredHeight}px`;
}

</script>
<template>
    <HeaderDetailsPage titulo="Desempenho dos alunos" :loading="loading" />
    <div class="flex flex-column">
        <DataTable :value="estudantes" tableStyle="min-width: 50rem" :scrollHeight="tableHeight" stripedRows scrollable
            resizableColumns columnResizeMode="fit" style="margin-top: 60px;" size="large" showGridlines>
            <template #header>
                <div class="flex align-items-center justify-content-end">
                    <div style="text-align:left">
                        <Dropdown filter v-model="turmaSelecionada" showClear :options="turmas" optionLabel="nome"
                            placeholder="Selecione uma turma" class="w-15rem" display="chip" />
                    </div>
                </div>
            </template>

            <Column field="nome" frozen sortable class="w-13rem">
                <template #header>
                    <div class="text-xs font-medium truncate">{{ "Nome do Aluno" }}</div>
                </template>
                <template #body="{ data }">
                    <div class="flex align-items-center gap-2" @click="verDetalhesAluno(data)">
                        <img :src="data.img" :alt="data.nome"
                            style="min-width:60px; min-height: 60px; max-width:60px; max-height: 60px; border-radius:50%; object-fit: cover;">
                        <span v-tooltip.bottom="data.nome">
                            <div class="text-sm font-medium truncate2 text-color mb-1">{{ data.nome }}</div>
                            <div class="text-xs text-color-secondary"></div>
                        </span>
                    </div>
                </template>
            </Column>
            <Column field="riscoReprovacao" sortable class="w-13rem">
                <template #header>
                    <div class="text-xs font-medium truncate">{{ " Média" }}</div>
                </template>
                <template #body="{ data }">
                    <div class="flex align-items-center gap-2 justify-content-center"
                        v-tooltip.bottom="`Baseado em ${data.notasMaiorQueZero} avaliações (critérios diferentes de rubricas usadas nos planos de aula)`">
                        <Tag class="block text-center w-5rem" :value="data.riscoReprovacao"
                            :severity="getSeverityFromNota(data.riscoReprovacao)" />
                    </div>
                </template>
            </Column>
            <Column field="mediaHumanas" sortable class="w-13rem">
                <template #header>
                    <div class="text-xs font-medium truncate">{{ " Desempenho Humanas" }}</div>
                </template>
                <template #body="{ data }">
                    <div class="flex align-items-center gap-2 justify-content-center">
                        <Tag class="block text-center w-5rem" :value="data.mediaHumanas"
                            :severity="getSeverityFromNota(data.mediaHumanas)" />
                    </div>
                </template>
            </Column>
            <Column field="mediaLinguagens" sortable class="w-13rem">
                <template #header>
                    <div class="text-xs font-medium truncate">{{ " Desempenho Linguagens" }}</div>
                </template>
                <template #body="{ data }">
                    <div class="flex align-items-center gap-2 justify-content-center">
                        <Tag class="block text-center truncate  w-5rem" :value="data.mediaLinguagens"
                            :severity="getSeverityFromNota(data.mediaLinguagens)" />
                        <span>
                            <div class="text-sm font-medium truncate2 text-color mb-1">

                            </div>
                        </span>
                    </div>
                </template>
            </Column>
            <Column field="mediaNatureza" sortable class="w-13rem">
                <template #header>
                    <div class="text-xs font-medium truncate">{{ " Desempenho Matemática" }}</div>
                </template>
                <template #body="{ data }">
                    <div class="flex align-items-center gap-2 justify-content-center">
                        <Tag class="block text-center truncate w-5rem" :value="data.mediaMatematica"
                            :severity="getSeverityFromNota(data.mediaMatematica)" />
                        <span>
                            <div class="text-sm font-medium truncate2 text-color mb-1">

                            </div>
                        </span>
                    </div>
                </template>
            </Column>
            <Column field="mediaNatureza" sortable class="w-13rem">
                <template #header>
                    <div class="text-xs font-medium truncate">{{ " Desempenho Natureza" }}</div>
                </template>
                <template #body="{ data }">
                    <div class="flex align-items-center gap-2 justify-content-center">
                        <Tag class="block text-center truncate w-5rem" :value="data.mediaNatureza"
                            :severity="getSeverityFromNota(data.mediaNatureza)" />
                        <span>
                            <div class="text-sm font-medium truncate2 text-color mb-1">

                            </div>
                        </span>
                    </div>
                </template>
            </Column>
        </DataTable>

    </div>
</template>